import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ReceptionMemberships.css";
import {
  fetchAllMemberships,          // shim below
  fetchMembershipPlans,         // shim below
  createMembershipForUser,      // shim below
  changeMembershipPlan,         // shim below
  pauseMembership,              // shim below
  resumeMembership,             // shim below
  cancelMembership,             // shim below
  resendMembershipReceipt,      // shim below
  previewMembershipProration    // shim below
} from "../../../../../../Utilities/api/index.js";

function safeString(v){ if(v===null||v===undefined) return ""; return String(v); }
function lower(v){ return safeString(v).toLowerCase(); }
function includesText(h,n){ var H=lower(h); var N=lower(n); if(!N) return true; return H.indexOf(N)!==-1; }
function formatMoney(n){ if(typeof n!=="number") n=0; try{ return "$"+n.toFixed(2); }catch(e){ return "$"+String(n); } }
function toDateLabel(s){
  if(!s) return "—";
  try{
    var d=new Date(s);
    if(isNaN(d.getTime())) return "—";
    return d.toLocaleDateString()+" "+d.toLocaleTimeString();
  }catch(e){ return "—"; }
}

var ITEMS_PER_PAGE = 10;

const ReceptionMemberships = function(){
  var navigate = useNavigate();

  var _useState1 = useState(false), loading = _useState1[0], setLoading = _useState1[1];
  var _useState2 = useState(""), error = _useState2[0], setError = _useState2[1];

  var _useState3 = useState([]), memberships = _useState3[0], setMemberships = _useState3[1];
  var _useState4 = useState([]), plans = _useState4[0], setPlans = _useState4[1];

  // Filters
  var _useState5 = useState("all"), statusFilter = _useState5[0], setStatusFilter = _useState5[1]; // active|paused|canceled|all
  var _useState6 = useState("all"), planFilter = _useState6[0], setPlanFilter = _useState6[1];
  var _useState7 = useState(""), search = _useState7[0], setSearch = _useState7[1];

  // Pagination
  var _useState8 = useState(1), currentPage = _useState8[0], setCurrentPage = _useState8[1];

  // Modals
  var _useState9 = useState(false), showCreate = _useState9[0], setShowCreate = _useState9[1];
  var _useState10 = useState(false), showChange = _useState10[0], setShowChange = _useState10[1];

  // Create modal data
  var _useState11 = useState(""), newUserId = _useState11[0], setNewUserId = _useState11[1];
  var _useState12 = useState(""), newPlanId = _useState12[0], setNewPlanId = _useState12[1];
  var _useState13 = useState(""), newPaymentMethodId = _useState13[0], setNewPaymentMethodId = _useState13[1];

  // Change modal data
  var _useState14 = useState(null), targetMembership = _useState14[0], setTargetMembership = _useState14[1];
  var _useState15 = useState(""), targetNewPlanId = _useState15[0], setTargetNewPlanId = _useState15[1];
  var _useState16 = useState(null), prorationPreview = _useState16[0], setProrationPreview = _useState16[1];

  // Load data
  useEffect(function(){
    async function run(){
      setLoading(true); setError("");
      try{
        var list = await fetchAllMemberships();
        if(Array.isArray(list)) setMemberships(list); else setMemberships([]);

        var pl = await fetchMembershipPlans();
        if(Array.isArray(pl)) setPlans(pl); else setPlans([]);
      }catch(e){
        setError((e&&e.message)||"Failed to load memberships"); setMemberships([]); setPlans([]);
      }finally{ setLoading(false); }
    }
    run();
  }, []);

  // Helpers (filters)
  function statusMatches(m,want){
    if(want==="all") return true;
    var s = m && m.status ? lower(m.status) : "";
    return s === lower(want);
  }
  function planMatches(m,want){
    if(want==="all") return true;
    var pid = m && m.planId ? safeString(m.planId) : "";
    var pname = m && m.planName ? m.planName : "";
    if(pid === want) return true;
    if(includesText(pname,want)) return true;
    return false;
  }
  function searchMatches(m,q){
    if(!q || q.trim()==="") return true;
    var owner = m && m.ownerName ? m.ownerName : (m && m.userEmail ? m.userEmail : "");
    var petNames = m && m.petNames ? m.petNames : "";
    var ref = m && m.reference ? m.reference : "";
    var idStr = safeString(m && m.id);

    if(includesText(owner,q)) return true;
    if(includesText(petNames,q)) return true;
    if(includesText(ref,q)) return true;
    if(includesText(idStr,q)) return true;
    return false;
  }

  function filterMemberships(list){
    var out = [];
    var i=0;
    while(i<list.length){
      var m = list[i];
      if(!statusMatches(m,statusFilter)){ i=i+1; continue; }
      if(!planMatches(m,planFilter)){ i=i+1; continue; }
      if(!searchMatches(m,search)){ i=i+1; continue; }
      out.push(m);
      i=i+1;
    }
    return out;
  }

  var filtered = filterMemberships(memberships);

  // Pagination
  var totalPages = Math.max(1, Math.ceil(filtered.length / ITEMS_PER_PAGE));
  var startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  var endIndex = startIndex + ITEMS_PER_PAGE;
  var pageItems = [];
  var idx = startIndex;
  while(idx<filtered.length && idx<endIndex){ pageItems.push(filtered[idx]); idx=idx+1; }

  useEffect(function(){ if(currentPage>totalPages) setCurrentPage(1); }, [totalPages, currentPage]);

  // Actions
  async function reload(){
    try{
      var list = await fetchAllMemberships();
      if(Array.isArray(list)) setMemberships(list);
    }catch(e){}
  }

  async function onCreateMembership(){
    if(!newUserId || !newPlanId){
      alert("User ID and Plan are required.");
      return;
    }
    try{
      setLoading(true);
      await createMembershipForUser(newUserId, { planId:newPlanId, paymentMethodId:newPaymentMethodId });
      setShowCreate(false); setNewUserId(""); setNewPlanId(""); setNewPaymentMethodId("");
      await reload();
    }catch(e){ alert((e&&e.message)||"Failed to create membership"); }
    finally{ setLoading(false); }
  }

  function openChangeModal(m){
    setTargetMembership(m);
    setTargetNewPlanId("");
    setProrationPreview(null);
    setShowChange(true);
  }

  async function onPreviewProration(){
    if(!targetMembership || !targetNewPlanId){ alert("Choose a plan to preview."); return; }
    try{
      var prev = await previewMembershipProration(targetMembership.id, targetNewPlanId);
      setProrationPreview(prev || null);
    }catch(e){ alert((e&&e.message)||"Preview failed"); }
  }

  async function onChangePlan(){
    if(!targetMembership || !targetNewPlanId){ alert("Select a plan."); return; }
    try{
      setLoading(true);
      await changeMembershipPlan(targetMembership.id, { newPlanId: targetNewPlanId });
      setShowChange(false); setTargetMembership(null); setTargetNewPlanId(""); setProrationPreview(null);
      await reload();
    }catch(e){ alert((e&&e.message)||"Change plan failed"); }
    finally{ setLoading(false); }
  }

  async function onPause(m){
    try{ await pauseMembership(m.id); await reload(); }catch(e){ alert((e&&e.message)||"Pause failed"); }
  }
  async function onResume(m){
    try{ await resumeMembership(m.id); await reload(); }catch(e){ alert((e&&e.message)||"Resume failed"); }
  }
  async function onCancel(m){
    var confirmEnd = window.confirm("Cancel membership #"+safeString(m&&m.id)+" at period end?");
    try{ await cancelMembership(m.id, { cancelAtPeriodEnd: true, confirm: confirmEnd }); await reload(); }
    catch(e){ alert((e&&e.message)||"Cancel failed"); }
  }
  async function onReceipt(m){
    try{ await resendMembershipReceipt(m.id); alert("Receipt sent."); }
    catch(e){ alert((e&&e.message)||"Failed to send receipt"); }
  }

  // UI helpers
  function planLabelById(pid){
    var i=0;
    while(i<plans.length){
      var p = plans[i];
      if(safeString(p && p.id)===safeString(pid)){
        var price = (p && typeof p.price==="number") ? " · "+formatMoney(p.price) : "";
        return safeString(p && p.name)+price;
      }
      i=i+1;
    }
    return safeString(pid);
  }

  return (
    <div className="rmx-container">
      <div className="rmx-header">
        <h2>Reception · Memberships</h2>
        <div className="rmx-filters">
          <select className="rmx-select" value={statusFilter}
            onChange={function(e){ setStatusFilter(e.target.value); setCurrentPage(1); }}>
            <option value="all">All Statuses</option>
            <option value="active">Active</option>
            <option value="paused">Paused</option>
            <option value="canceled">Canceled</option>
          </select>

          <select className="rmx-select" value={planFilter}
            onChange={function(e){ setPlanFilter(e.target.value); setCurrentPage(1); }}>
            <option value="all">All Plans</option>
            {plans.map(function(p){
              return <option key={p.id} value={safeString(p.id)}>{safeString(p.name)}</option>;
            })}
          </select>

          <input className="rmx-input" placeholder="Search owner, pet, id, ref"
            value={search}
            onChange={function(e){ setSearch(e.target.value); setCurrentPage(1); }} />

          <button className="rmx-btn primary" onClick={function(){ setShowCreate(true); }}>New Membership</button>
        </div>
      </div>

      {loading ? <div className="rmx-state">Loading…</div> : null}
      {error ? <div className="rmx-state error">Error: {error}</div> : null}

      {!loading && !error && pageItems.length===0 ? (
        <div className="rmx-empty">No memberships match your filters.</div>
      ) : null}

      <div className="rmx-list">
        {pageItems.map(function(m){
          var status = m && m.status ? m.status : "active";
          var planName = m && m.planName ? m.planName : planLabelById(m && m.planId);
          var priceNumber = (m && typeof m.price==="number") ? m.price : (m && m.planPrice ? m.planPrice : 0);
          var nextBill = m && m.nextBillingDate ? toDateLabel(m.nextBillingDate) : "—";
          var owner = m && m.ownerName ? m.ownerName : (m && m.userEmail ? m.userEmail : "—");
          var pets = m && m.petNames ? m.petNames : "—";

          var canPause = status==="active";
          var canResume = status==="paused";
          var canCancel = status!=="canceled";

          return (
            <div key={m.id} className="rmx-row">
              <div className="rmx-main" onClick={function(){ /* optional details route */ }}>
                <div className="rmx-line1">
                  <span className="rmx-id">#{safeString(m && m.id)}</span>
                  <span className={"rmx-badge "+status}>{lower(status)}</span>
                  <span className="rmx-plan">{safeString(planName)}</span>
                  <span className="rmx-price">{formatMoney(Number(priceNumber||0))}</span>
                </div>
                <div className="rmx-line2">
                  <span>Owner: {owner}</span>
                  <span>Pets: {pets}</span>
                  <span>Next bill: {nextBill}</span>
                  <span>Ref: {safeString(m && m.reference)}</span>
                </div>
              </div>

              <div className="rmx-actions">
                <button className="rmx-btn" onClick={function(){ onReceipt(m); }}>Receipt</button>
                <button className="rmx-btn" onClick={function(){ openChangeModal(m); }}>Change Plan</button>
                {canPause ? <button className="rmx-btn" onClick={function(){ onPause(m); }}>Pause</button> : null}
                {canResume ? <button className="rmx-btn" onClick={function(){ onResume(m); }}>Resume</button> : null}
                {canCancel ? <button className="rmx-btn warn" onClick={function(){ onCancel(m); }}>Cancel</button> : null}
              </div>
            </div>
          );
        })}
      </div>

      <div className="rmx-pagination">
        <button className="rmx-btn" disabled={currentPage===1}
          onClick={function(){ setCurrentPage(currentPage-1); }}>Previous</button>
        <span className="rmx-pageinfo">Page {currentPage} of {totalPages}</span>
        <button className="rmx-btn" disabled={currentPage===totalPages}
          onClick={function(){ setCurrentPage(currentPage+1); }}>Next</button>
      </div>

      {/* Create modal */}
      {showCreate ? (
        <div className="rmx-modal">
          <div className="rmx-card">
            <div className="rmx-card-title">New Membership</div>
            <label className="rmx-field">
              <span>User ID</span>
              <input className="rmx-input" value={newUserId}
                onChange={function(e){ setNewUserId(e.target.value); }} />
            </label>

            <label className="rmx-field">
              <span>Plan</span>
              <select className="rmx-select" value={newPlanId}
                onChange={function(e){ setNewPlanId(e.target.value); }}>
                <option value="">Select a plan</option>
                {plans.map(function(p){
                  var label = safeString(p && p.name)+" — "+formatMoney(Number(p && p.price ? p.price : 0));
                  return <option key={p.id} value={safeString(p.id)}>{label}</option>;
                })}
              </select>
            </label>

            <label className="rmx-field">
              <span>Payment Method ID (optional)</span>
              <input className="rmx-input" value={newPaymentMethodId}
                onChange={function(e){ setNewPaymentMethodId(e.target.value); }} />
            </label>

            <div className="rmx-actions end">
              <button className="rmx-btn" onClick={onCreateMembership}>Create</button>
              <button className="rmx-btn ghost" onClick={function(){ setShowCreate(false); }}>Cancel</button>
            </div>
          </div>
        </div>
      ) : null}

      {/* Change plan modal */}
      {showChange ? (
        <div className="rmx-modal">
          <div className="rmx-card">
            <div className="rmx-card-title">
              Change Plan · #{targetMembership ? safeString(targetMembership.id) : ""}
            </div>

            <label className="rmx-field">
              <span>New Plan</span>
              <select className="rmx-select" value={targetNewPlanId}
                onChange={function(e){ setTargetNewPlanId(e.target.value); }}>
                <option value="">Select a plan</option>
                {plans.map(function(p){
                  var label = safeString(p && p.name)+" — "+formatMoney(Number(p && p.price ? p.price : 0));
                  return <option key={p.id} value={safeString(p.id)}>{label}</option>;
                })}
              </select>
            </label>

            <div className="rmx-actions">
              <button className="rmx-btn" onClick={onPreviewProration}>Preview Proration</button>
              {prorationPreview ? (
                <div className="rmx-proration">
                  <div>Immediate charge: <strong>{formatMoney(Number(prorationPreview.immediateCharge||0))}</strong></div>
                  <div>Next invoice adj: <strong>{formatMoney(Number(prorationPreview.nextInvoiceAdjustment||0))}</strong></div>
                </div>
              ) : null}
            </div>

            <div className="rmx-actions end">
              <button className="rmx-btn" onClick={onChangePlan}>Confirm Change</button>
              <button className="rmx-btn ghost" onClick={function(){ setShowChange(false); }}>Close</button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ReceptionMemberships;
